import { Icons } from "../../constants/icon-library";
import moment from "moment/moment";
import { BeatLoader } from "react-spinners";
import ReactPaginate from "react-paginate";

const override = {
  display: "block",
  margin: "0 auto",
  textAlign: "center",
  padding: "20px",
};

function TransactionTable({
  transactionsData,
  loading,
  onPageChange,
  planDetails,
  manageSubscription,
  addCredits,
}) {
  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    onPageChange(selectedPage);
  };

  return (
    <div className="card border-0 shadow-lg">
      <div className="card-body p-5">
        <div className="d-flex align-items-center justify-content-between mb-4 w-100">
          <h2 className="fw-bold mb-0">Transactions</h2>

          <div className="d-flex gap-2">
            <button
              onClick={() => planDetails()}
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
            >
              <i className={`wb ${Icons("payment")}`}></i>
              Plan Details
            </button>

            <button
              onClick={() => manageSubscription()}
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
            >
              <i className="wb webconnect-gear"></i>
              Manage Subscription
            </button>

            <button
              onClick={() => addCredits()}
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
            >
              <i className="wb webconnect-plus-circle"></i>
              Buy More Credits
            </button>
          </div>
        </div>
        <div className="mb-4" style={{ borderTop: "1px solid #2a2a3e" }}>
          <div id="table-Consumers">
            {loading ? (
              <BeatLoader
                loading={true}
                cssOverride={override}
                color="var(--phoenix-emphasis-color)"
                size="10px"
              />
            ) : (
              <div
                className="table-responsive"
                style={{ width: "100%", overflowX: "auto" }}
              >
                <table className="table table-sm table-striped fs-9 mb-0 w-100">
                  <thead>
                    <tr>
                      <th
                        className="sort border-top ps-3 align-middle"
                        data-splatformort="transaction"
                      >
                        Transaction
                      </th>
                      <th
                        className="sort border-top ps-3 align-middle"
                        data-sort="date"
                      >
                        Date
                      </th>
                      <th
                        className="sort border-top ps-3 align-middle"
                        data-sort="credits"
                      >
                        Credits
                      </th>
                    </tr>
                  </thead>
                  <tbody className="list">
                    {transactionsData?.transactions?.length > 0 &&
                      transactionsData.transactions.map((transaction) => (
                        <tr key={transaction.uuid}>
                          <td className="align-middle ps-3 transaction">
                            <i
                              className={`wb ${Icons(
                                transaction.type === "CREDIT"
                                  ? "credited"
                                  : "apiUsage",
                              )}`}
                              style={{ fontSize: "1rem" }}
                            ></i>
                            &nbsp; {transaction.description}
                          </td>
                          <td className="align-middle ps-3 date">
                            {moment
                              .utc(transaction.createdAt)
                              .format("MMM D, YYYY • h:mm A")}
                          </td>
                          <td>{transaction.credits}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-3 d-flex">
              {transactionsData?.total > 10 && (
                <ReactPaginate
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={transactionsData.totalPages}
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  nextClassName="page-item"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  containerClassName="pagination pagination-sm justify-content-center"
                  activeClassName="active"
                  breakLabel={"..."}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionTable;
